import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../theme/constants';

export const ChartWrapper = styled.div`
   position: relative;
   margin-bottom: 20px;

   @media (max-width: 1200px) {
      border-left: 1px solid ${COLOR.LIGHTGREY};
      border-right: 1px solid ${COLOR.LIGHTGREY};
      overflow: auto;
      margin-bottom: 0px;
   }
`;

export const ChartContainer = styled.div`
   position: relative;
   margin-bottom: 20px;

   @media (max-width: 1200px) {
      overflow: auto;
      padding: 0 14px;
   }
`;

export const ValuePropositionContainer = styled.div`
   width: 100%;
   margin-top: 55px;
   margin-bottom: 48px;
   display: flex;
   align-item: center;
   justify-content: center;
`;

export const ChartLogin = styled.div`
   height: 450px;
   width: 100%;
   padding-top: 75px;
`;

export const ChartNoAccess = styled.div`
   display: block;
   min-height: 250px;
   text-align: center;
   font-size: 20px;

   @media only screen and (min-width: 768px) {
      min-height: 450px;
   }
`;

export const ChartNoAccessTitle = styled.div`
   color: ${COLOR.RED};
   font-size: 1.5em;
   padding: 0 0 20px 0;
   ${TYPOGRAPHY.BOLD};

   @media only screen and (min-width: 768px) {
      padding: 60px 0 20px 0;
      font-size: 2em;
   }

   @media only screen and (min-width: 1250px) {
      padding: 90px 0 20px 0;
      font-size: 2.5em;
   }
`;

export const ChartNoAccessContent = styled.div`
   font-size: 0.8em;
   margin: 0 0 45px 0;
   color: #666;

   @media only screen and (min-width: 768px) {
      font-size: 1.1em;
   }

   @media only screen and (min-width: 1250px) {
      font-size: 1em;
   }
`;

export const ChartNoAccessButton = styled.div`
   font-size: 1em;
   background-color: ${COLOR.BLUE_BACKGROUND};
   box-shadow: inset 0 0 0 0 ${COLOR.BLUE_PRIMARY};
   color: ${COLOR.WHITE};
   display: inline;
   padding: 10px;
   border-radius: 10px;
   -webkit-transition: all ease 0.8s;
   -moz-transition: all ease 0.8s;
   transition: all ease 0.8s;
   cursor: pointer;
   ${TYPOGRAPHY.BOLD};

   @media only screen and (min-width: 768px) {
      font-size: 1.2em;
      padding: 10px 60px;
   }

   @media only screen and (min-width: 1250px) {
      font-size: 1.2em;
      padding: 10px 60px;
   }

   &:hover,
   &:visited,
   &:focus {
      box-shadow: inset 0 100px 0 0 ${COLOR.BLUE_PRIMARY};
      text-decoration: none;
      color: ${COLOR.WHITE};
   }
`;

export const ChartNoAccessButtonLink = styled.a`
   text-decoration: none;
   color: ${COLOR.WHITE};

   :hover,
   &:visited,
   &:focus {
      text-decoration: none;
      color: ${COLOR.WHITE};
   }
`;

export const MobileActionsWrapper = styled.div`
   @media (max-width: 1200px) {
      border-left: 1px solid ${COLOR.LIGHTGREY};
      border-right: 1px solid ${COLOR.LIGHTGREY};
      border-bottom: 1px solid ${COLOR.LIGHTGREY};
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      overflow: auto;
      padding: 0 15px;
      margin-bottom: 35px;
      //min-height: 133px;
      min-height: 25px;
   }
`;
